import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import services from '@/services';
import type { PinSurvey } from '@/services/surveyService';
import { useMainStore } from '@/store';
export const usePinSurveyMutation = () => {
  const $ = _c(7);
  const queryClient = useQueryClient();
  const {
    currentUser
  } = useMainStore();
  let t0;
  if ($[0] !== currentUser) {
    t0 = async t1 => {
      const {
        surveyId,
        isPinned
      } = t1;
      const payload = {
        userId: currentUser.id,
        surveyId
      };
      if (isPinned) {
        await services.survey.unpinSurvey(payload);
      } else {
        await services.survey.pinSurvey(payload);
      }
    };
    $[0] = currentUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== queryClient) {
    t1 = async () => {
      queryClient.invalidateQueries({
        queryKey: ["surveys-infinite"]
      });
    };
    $[2] = queryClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      mutationFn: t0,
      onSuccess: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useMutation(t2);
};